/**
 * @version 1.0.1
 * @author pengxf
 * @createTime:2021-10-08,
 * @updateTime:2021-10-08
 * @copyright thunisoft fd
 */
import linkMixins from './mixin/link.js';
import ccTab from '@/components/common/tab/index.vue';
import kypm from './kypm/index.vue';
export default {
    name: 'ssfw',
    components: {ccTab, kypm},
    data() {
        return {
            crumbsList:Object.freeze([{
                name:'诉讼服务',
                key:'ssfw'
            }]),
            data: {
                sdgg: {data: []},
                ktgg: {data: []},
                xg: {data: []},
                cg: {data: []},
                pbmgg: {data: []},
                qtgg: {data: []}
            },
            tabList: [
                {
                    name: '诉服链接',
                    code: 'ssfw'
                },
                {
                    name: '扣押拍卖',
                    code: 'kypm'
                },
                {
                    name: '法院公告',
                    code: 'fygg'
                }
            ],
            activeTab:''
        };
    },
    mixins:[linkMixins],
    mounted() {
        this.init();
    },
    methods: {

        init() {
            const _this = this;
            this.activeTab = this.$route.query.tab ? this.$route.query.tab : 'ssfw';
            const url = window.fdConfig.url.home.latestFygg;
            window.fdGlobal.ajax.get(url)
                .then((res) => {
                    if (res.data) {
                        const result = res.data;
                        this.fyggData = result;
                        // 送达公告对应的code为6
                        if (result[6]) {
                            _this.data.sdgg.data = result[6];
                        }
                        if (result[7]) {
                            _this.data.ktgg.data = result[7];
                        }
                        if (result[8]) {
                            _this.data.xg.data = result[8];
                        }
                        if (result[9]) {
                            _this.data.cg.data = result[9];
                        }
                        if (result[10]) {
                            _this.data.pbmgg.data = result[10];
                        }
                        if (result[12]) {
                            _this.data.qtgg.data = result[12];
                        }
                    }
                });
        },
        openLarge() {
            this.$refs.ydwfy.open();
        },
        changeTab(item) {
            this.activeTab = item;
        },
        // 查看更多
        handleMore(type) {
            this.$router.push({
                path: '/ssfw/more',
                query: {tab: type}
            });
        },
        // 查看详情
        handleDetail(item) {
            const url = this.$router.resolve({path: '/xwzxDetail', query: {active:'ssfw', bh: item.bh, fileType: 21}});
            window.open(url.href, '_blank');
            window.console.log('查看详情', item);
        }
    }
};

